
export default {
  name: 'FullpageBlok',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
